import { Box, CardContent, Grid, Typography } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import BoltIcon from "@mui/icons-material/Bolt";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";

import { brands } from "../../../data/brandsAndProjectsData";
import { useLanguageContext } from "../../../context/languageContext";
import { textlanguages } from "../../../data/textOfThePage";

export const ProjectInformationCard = ({
  companySelected,
  projectSelected,
}) => {
  const { languageSelected } = useLanguageContext();
  return (
    <Box
      sx={{
        borderRadius: 4,
        boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
        p: 2,
        my: "50px",
        width: { xs: "90%", md: "800px" },
      }}
    >
      <CardContent>
        <Typography
          component="h2"
          gutterBottom
          fontWeight="bold"
          fontSize={"25px"}
        >
          {
            brands[languageSelected][companySelected]?.projects[projectSelected]
              .name
          }
        </Typography>

        <Grid container spacing={3} mt={2}>
          <Grid item xs={12} md={6}>
            <InfoSection
              icon={<BusinessIcon fontSize="large" />}
              category={
                textlanguages[languageSelected].portfolio.projectInformationCard
                  .client
              }
              value={
                brands[languageSelected][companySelected]?.projects[
                  projectSelected
                ].client
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoSection
              icon={<BoltIcon fontSize="large" />}
              category={
                textlanguages[languageSelected].portfolio.projectInformationCard
                  .industry
              }
              value={
                brands[languageSelected][companySelected]?.projects[
                  projectSelected
                ].industry
              }
            />
          </Grid>
          <Grid item xs={12}>
            <InfoSection
              icon={<PhoneIphoneIcon fontSize="large" />}
              category={`${textlanguages[languageSelected].portfolio.projectInformationCard.Service} Greedy`}
              value={
                brands[languageSelected][companySelected]?.projects[
                  projectSelected
                ].services
              }
            />
          </Grid>
        </Grid>
      </CardContent>
    </Box>
  );
};

const InfoSection = ({ icon, category, value }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
    <Box sx={{ color: "#005587" }}>{icon}</Box>
    <Box>
      <Typography variant="body2" color="text.secondary">
        {category}
      </Typography>
      <Typography variant="subtitle1" fontWeight="medium">
        {value}
      </Typography>
    </Box>
  </Box>
);
